'use client';

import { useCallback, type FC } from 'react';
import { Button } from '../../components/ui/Button';
import { showErrorToast, showInfoToast } from '../../components/Toast';
import { shareNews } from './shareNews';

export interface NewsShareButtonProps {
  title: string;
  description: string;
  url: string;
  label: string;
  ariaLabel: string;
  copiedText: string;
  copyFailedText: string;
  variant?: 'primary' | 'secondary';
  className?: string;
}

const ShareIcon: FC = () => (
  <svg aria-hidden viewBox="0 0 24 24" width={18} height={18} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v12" />
    <path d="m7.5 7.5 4.5-4.5 4.5 4.5" />
    <path d="M8 10.5H6.5A1.5 1.5 0 0 0 5 12v7.5A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V12a1.5 1.5 0 0 0-1.5-1.5H16" />
  </svg>
);

export const NewsShareButton: FC<NewsShareButtonProps> = ({
  title,
  description,
  url,
  label,
  ariaLabel,
  copiedText,
  copyFailedText,
  variant = 'secondary',
  className,
}) => {
  const share = useCallback(async () => {
    const result = await shareNews({ title, description, url }, navigator);
    if (result === 'copied') showInfoToast(copiedText);
    if (result === 'failed') showErrorToast(copyFailedText);
  }, [title, description, url, copiedText, copyFailedText]);

  return (
    <Button type="button" variant={variant} aria-label={ariaLabel} before={<ShareIcon />} className={className} onClick={() => void share()}>
      {label}
    </Button>
  );
};
